import { compose } from "redux";
import { map, sort } from "../../../helpers/fp";
import logger from "../../../lib/logger";
import { getBrands } from "../../../lib/api/navigation";
import { receiveBrands, requestBrands } from ".";
import {
  byKey,
  byTitle,
  titleLinkAndChannelExclusions,
  groupByFirstCharOfTitle
} from "./helpers";

const transformBrands = compose(
  sort(byKey),
  Object.entries,
  groupByFirstCharOfTitle,
  sort(byTitle),
  map(titleLinkAndChannelExclusions)
);

const buildReceiveBrandsAction = json =>
  receiveBrands({
    title: json.content.title,
    groups: transformBrands(json.children)
  });

export const fetchBrands = ({
  country = null,
  query = { cid: null },
  uuid = null,
  xSiteOrigin = null
}) => dispatch => {
  dispatch(requestBrands());

  return getBrands({ country, query, uuid, xSiteOrigin })
    .then(response => dispatch(buildReceiveBrandsAction(response[0])))
    .catch(error => {
      error.message = `getBrands failed, and caught error: ${error.message}`;
      logger.error(error);
      if (SERVER) {
        throw error;
      }
    });
};
